import { createStorefrontApiClient } from '@shopify/storefront-api-client'

export const storefrontClient = createStorefrontApiClient({
  storeDomain: window.Shopify.shop,
  apiVersion: '2025-04',
  publicAccessToken: window.Lounge.integrations.storefront_api_public_key,
})
